import React, {Component} from 'react';
import _ from 'lodash';
import {Card, Grid, Header, Icon, GridColumn} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import PanelReviewCardV2 from 'go/components/panelReview2/panelReviewCard';
import {HOME_PAGE} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {Toggle} from 'componentLibrary';
import FemaActions from './FemaActions';

const taskUrl = '/tasks/';

const bodyCopyHMA =
  'FEMA Grants Outcomes (GO) supports the Preparedness: Fire & Life Safety and Mitigation: Hazards categories of grant programs.  As the application is developed, more functionality and grant programs will be available for your use.';
const bodyCopyHMAandIA =
  'FEMA Grants Outcomes (GO) supports the Preparedness: Fire & Life Safety, Mitigation: Hazards and Recovery: Assistance to Individuals categories of grant programs. As the application is developed, more functionality and grant programs will be available for your use.';
const bodyTitle = "Welcome to FEMA's new grant system!";


export default class FemaLandingPage extends Component {
  componentDidMount() {
    document.title = HOME_PAGE;
  }

  renderCards() {
    return (
      <React.Fragment>
        <React.Fragment>
          <Toggle toggle="panelReviewV2">
            <PanelReviewCardV2
              jwt={this.props.jwt}
              permissions={this.props.permissions}
              toggles={this.props.toggles}
            />
          </Toggle>
        </React.Fragment>
      </React.Fragment>
    );
  }

  render() {
    const {permissions, jwt, toggles} = this.props;
    const femaIAApplicationToggle = _.includes(this.props.toggles, 'femaIAApplication');
    const appDevAndSubToggle = _.includes(this.props.toggles, 'appDevAndSub1-1');
    const femaHomePageV2Toggle = _.includes(this.props.toggles, 'femaHomePageV2');
    return (
      <Grid>
        {!appDevAndSubToggle && 
        <Grid.Row>
          <Grid.Column width={12}>
            <Card fluid>
              <Card.Content className="leadParagraph">
                <Header as="h3"> {bodyTitle}</Header>
                <p>{femaIAApplicationToggle ? bodyCopyHMAandIA : bodyCopyHMA}</p>
              </Card.Content>
            </Card>
          </Grid.Column>
        </Grid.Row>}
        {this.renderCards()}
        { femaHomePageV2Toggle &&
          <Grid.Row className='homepage-row-spacing'>
            <Grid.Column width={12}>
              <FemaActions
                token={jwt}
                permissions={permissions}
              />
            </Grid.Column>
        </Grid.Row>
        }
      </Grid>
    );
  }
}
